import React from 'react';
import { motion } from 'framer-motion';
const solutions = [{
  icon: '📚',
  title: 'Recetas Visuales',
  description: 'Fichas de receta ultra visuales con foto real, ingredientes claros y pasos simples. Vas a saber exactamente qué cocinar cada día.'
}, {
  icon: '🛒',
  title: 'Solo Ingredientes de Feria',
  description: 'Cero ingredientes raros o importados. Todo lo que vas a necesitar lo encontrás en tu verdulería, almacén o súper de barrio.'
}, {
  icon: '⚡',
  title: 'Resultados Desde el Primer Día',
  description: 'Estructura editorial tipo revista de cocina premium. Abrís el tomo, elegís una receta y la hacés hoy mismo. Sin vueltas.'
}];
export function SolutionSection() {
  return <section className="bg-[#0a0a0a] py-12 px-4" data-id="element-186">
      <div className="max-w-6xl mx-auto" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-189">
            La Solución Definitiva para tu Cocina Vegetal
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-190">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-[#18181b] border border-zinc-800 rounded-xl p-6 relative overflow-hidden group" data-id="element-191">
              <div className="absolute top-0 left-0 w-full h-1 bg-emerald-600 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-192"></div>
              <div className="text-4xl mb-4" data-id="element-193">{item.icon}</div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-194">
                {item.title}
              </h3>
              <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-195">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}